import {createAsyncThunk} from '@reduxjs/toolkit';
import type {DesignerAttributionInfo} from '@Components/poster-editor/components/poster-editing-side-panel/components/designer-attribution/designer-attribution.types';
import type {RootState} from '@/store';

interface FetchDesignerAttributionResult {
  templateId: string;
  info: DesignerAttributionInfo;
}

export const fetchDesignerAttribution = createAsyncThunk<FetchDesignerAttributionResult, string, {state: RootState}>(
  'designerAttribution/fetch',
  async (templateId) => {
    const info = (await window.PMW.readLocal('user/getTemplateCreatorProfileInfo', {
      id: templateId,
    })) as DesignerAttributionInfo;
    return {templateId, info};
  },
  {
    condition: (templateId, {getState}) => {
      const {byTemplateId, pendingTemplateIds} = getState().designerAttribution;
      return byTemplateId[templateId] === undefined && !pendingTemplateIds[templateId];
    },
  }
);
